import React, { useState, useContext, useEffect } from "react";
import { Button, Paper, Typography, TableContainer, TableBody, TableCell, TableHead, TableRow, Table, IconButton, Stack, Box, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { isEmpty } from "lodash";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import PrintRoundedIcon from "@mui/icons-material/PrintRounded";
import ImageRoundedIcon from "@mui/icons-material/ImageRounded";
import { deleteToken, deleteUserData, getToken } from "../../../api/Account";
import { DataContext } from "../../../context/DataContext";

import { isAccess, simpleMessage } from "../../../helpers/Helpers";

import NoData from "../../../components/NoData";
import SmallModal from "../../../components/modals/SmallModal";
import MediumModal from "../../../components/modals/MediumModal";
import PreviewModal from "../../../components/modals/PreviewModal";

import Swal from "sweetalert2";
import AddAbono from "./quoteComponents/AddAbono";
import { cambiarMetodoPagoAsync, deleteQuoteAsync, deleteQuoteNominalAsync, getBillDetailsAsync, getCreditQuotesAsync } from "../../../api/Credits";
import DetalleAbono from "./quoteComponents/DetalleAbono";
import StatusChip from "../../../components/ui/StatusChip";
import { monoFont } from "../../../theme";

import moment from "moment/moment";

const money = (n) => new Intl.NumberFormat("es-NI", { style: "currency", currency: "NIO" }).format(n);

const CreditAbono = ({ id, isNominal }) => {
  const [quotesList, setQuotesList] = useState([]);
  const { setIsLoading, setIsLogged, setIsUnautorized, access, showPrintBillModal, setShowPrintBillModal, setDataAbono } = useContext(DataContext);
  const token = getToken();
  const [localReload, setLocalReload] = useState(false);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const result = await getCreditQuotesAsync(token, id);
      if (!result.statusResponse) {
        setIsLoading(false);
        if (result.error === "Unauthorized") {
          setIsUnautorized(true);
          return;
        }
        simpleMessage(result.error, "error");
        return;
      }

      setQuotesList(result.data.result);
      setIsLoading(false);
    })();
  }, [localReload]);

  const [addQuoteModal, setAddQuoteModal] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  const handleOpenComprobante = (imageUrl) => {
    setSelectedImage(imageUrl);
    setOpenModal(true);
  };

  const [metodoModal, setMetodoModal] = useState(false);
  const [quoteACambiar, setQuoteACambiar] = useState(null);
  const [entidadBancaria, setEntidadBancaria] = useState("");

  const puedeCambiarMetodo = isAccess(access, "CREDITS UPDATE");

  const aplicarMetodoPago = async (quoteId, metodoPago, entidad) => {
    setIsLoading(true);
    const result = await cambiarMetodoPagoAsync(token, { quoteId, metodoPago, entidadBancaria: entidad === "" ? null : entidad });
    if (!result.statusResponse) {
      setIsLoading(false);
      if (result.error === "Unauthorized") {
        setIsUnautorized(true);
        return;
      }
      simpleMessage(result.error, "error");
      return;
    }
    setIsLoading(false);
    setMetodoModal(false);
    setLocalReload(!localReload);
    simpleMessage("Forma de pago actualizada", "success");
  };

  const onClickMetodoPago = (row) => {
    if (row.metodoPago === 2) {
      // Transferencia -> Efectivo: no hace falta ningun dato extra.
      aplicarMetodoPago(row.id, 1, null);
      return;
    }
    // Efectivo -> Transferencia: el sistema no admite una transferencia sin saber por
    // que entidad entro el dinero, igual que al registrar el abono.
    setQuoteACambiar(row.id);
    setEntidadBancaria("");
    setMetodoModal(true);
  };

  const AnulateQuote = async (item) => {
    Swal.fire({
      title: "¿Estas Seguro?",
      text: "No podras revertir esto...!",
      icon: "warning",
      showCancelButton: true,

      confirmButtonColor: "#2979ff",
      cancelButtonColor: "#f50057",

      confirmButtonText: "Eliminar!",
      cancelButtonText: "Cancelar",
      customClass: {
        popup: "border",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        (async () => {
          setIsLoading(true);

          const result = isNominal ? await deleteQuoteNominalAsync(token, item) : await deleteQuoteAsync(token, item);

          if (!result.statusResponse) {
            setIsLoading(false);
            simpleMessage(result.error, "error");
            return;
          }
          if (result.error === "Unauthorized") {
            setIsLoading(false);
            deleteUserData();
            deleteToken();
            setIsLogged(false);
            return;
          }
          setIsLoading(false);
          setLocalReload(!localReload);
          Swal.fire("Eliminada!", "Quota Eliminada.", "success");
        })();
      }
    });
  };

  const reprintBill = async (quoteId) => {
    setIsLoading(true);
    const result = await getBillDetailsAsync(token, quoteId);
    if (!result.statusResponse) {
      setIsLoading(false);
      simpleMessage(result.error, "error");
      return;
    }
    if (result.error === "Unauthorized") {
      setIsLoading(false);
      deleteUserData();
      deleteToken();
      setIsLogged(false);
      return;
    }
    setIsLoading(false);
    setDataAbono(result.data.result);
    setShowPrintBillModal(true);
  };

  return (
    <div>
      <Paper sx={{ overflow: "hidden" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "16px 20px",
            borderBottom: "1px solid",
            borderColor: "divider",
            flexWrap: "wrap",
            gap: "10px",
          }}
        >
          <Typography sx={{ fontSize: 15, fontWeight: 600 }}>Abonos registrados</Typography>
          {isAccess(access, "CREDITS CREATE") ? (
            <Button onClick={() => setAddQuoteModal(true)} variant="contained" color="primary" size="small" startIcon={<AddRoundedIcon sx={{ fontSize: 17 }} />}>
              Agregar
            </Button>
          ) : null}
        </Box>

        {isEmpty(quotesList) ? (
          <NoData />
        ) : (
          <TableContainer sx={{ overflowX: "auto" }}>
            <Table size="small" sx={{ minWidth: 1080 }}>
              <TableHead>
                <TableRow>
                  <TableCell>#</TableCell>
                  <TableCell align="center">F.Pago</TableCell>
                  <TableCell align="right">Abono T.</TableCell>
                  <TableCell align="right">Saldo</TableCell>
                  <TableCell align="right">M.Atraso</TableCell>
                  <TableCell align="center">Ctas. atr.</TableCell>
                  <TableCell align="center">D.Mora</TableCell>
                  <TableCell>Concepto</TableCell>
                  <TableCell>Forma de Pago</TableCell>
                  <TableCell align="center">Estado</TableCell>
                  <TableCell align="center">Acciones</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {quotesList.map((row) => (
                  <TableRow key={row.id}>
                    <TableCell sx={{ fontFamily: monoFont, color: "text.disabled" }}>{row.id}</TableCell>
                    <TableCell align="center" sx={{ fontFamily: monoFont, fontSize: 12 }}>
                      {moment(row.fechaPago).format("L")}
                    </TableCell>
                    <TableCell align="right" sx={{ fontFamily: monoFont, fontWeight: 600, color: "success.main" }}>
                      {money(row.totalRecibido)}
                    </TableCell>
                    <TableCell align="right" sx={{ fontFamily: monoFont }}>
                      {money(row.nuevoSaldo)}
                    </TableCell>
                    <TableCell align="right" sx={{ fontFamily: monoFont }}>
                      {money(row.montoAtrasado)}
                    </TableCell>
                    <TableCell align="center" sx={{ fontFamily: monoFont }}>
                      {row.cuotasAtrasadas}
                    </TableCell>
                    <TableCell align="center" sx={{ fontFamily: monoFont }}>
                      {row.diasMora}
                    </TableCell>
                    <TableCell sx={{ fontSize: 12.5 }}>{row.concepto}</TableCell>
                    <TableCell sx={{ fontSize: 12.5 }}>
                      {puedeCambiarMetodo && !row.isAnulado ? (
                        <Button
                          size="small"
                          variant="outlined"
                          color={row.metodoPago === 2 ? "info" : "inherit"}
                          onClick={() => onClickMetodoPago(row)}
                          title="Cambiar forma de pago"
                          sx={{ fontSize: 11, textTransform: "none", py: 0, px: 1, minWidth: 0, whiteSpace: "nowrap" }}
                        >
                          {row.metodoPago === 2 ? "Transferencia" : "Efectivo"}
                        </Button>
                      ) : (
                        <>{row.metodoPago === 2 ? "Transferencia" : "Efectivo"}</>
                      )}
                    </TableCell>
                    <TableCell align="center">
                      <StatusChip label={row.isAnulado ? "Anulado" : "Aplicado"} tone={row.isAnulado ? "error" : "success"} />
                    </TableCell>
                    <TableCell align="center">
                      <Stack direction="row" spacing={0.3} justifyContent="center">
                        {isAccess(access, "CREDITS DELETE") ? (
                          <IconButton size="small" sx={{ color: "error.main" }} onClick={() => AnulateQuote(row.id)}>
                            <DeleteRoundedIcon sx={{ fontSize: 17 }} />
                          </IconButton>
                        ) : null}

                        <IconButton size="small" onClick={() => reprintBill(row.id)}>
                          <PrintRoundedIcon sx={{ fontSize: 17 }} />
                        </IconButton>

                        {row.comprobantePhoto ? (
                          <IconButton size="small" sx={{ color: "success.main" }} title="Ver comprobante" onClick={() => handleOpenComprobante(row.comprobantePhoto.imageFullPath)}>
                            <ImageRoundedIcon sx={{ fontSize: 17 }} />
                          </IconButton>
                        ) : null}
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Paper>

      <SmallModal titulo={"Agregar Abono"} isVisible={addQuoteModal} setVisible={setAddQuoteModal}>
        <AddAbono setShowModal={setAddQuoteModal} id={id} localReload={localReload} setLocalReload={setLocalReload} isNominal={isNominal} />
      </SmallModal>

      <MediumModal titulo={"Detalle Abono"} isVisible={showPrintBillModal} setVisible={setShowPrintBillModal}>
        <DetalleAbono setShowModal={setShowPrintBillModal} />
      </MediumModal>

      <SmallModal titulo={"Cambiar a Transferencia"} isVisible={metodoModal} setVisible={setMetodoModal}>
        <Stack spacing={2} sx={{ pt: 1 }}>
          <FormControl fullWidth sx={{ textAlign: "left" }}>
            <InputLabel id="entidad-bancaria-cambio-label">Entidad Bancaria</InputLabel>
            <Select labelId="entidad-bancaria-cambio-label" label="Entidad Bancaria" value={entidadBancaria} onChange={(e) => setEntidadBancaria(e.target.value)}>
              <MenuItem value={1}>LAFISE</MenuItem>
              <MenuItem value={2}>BILLETERA MÓVIL</MenuItem>
            </Select>
          </FormControl>

          <Button variant="contained" color="primary" disabled={entidadBancaria === ""} onClick={() => aplicarMetodoPago(quoteACambiar, 2, entidadBancaria)}>
            Cambiar forma de pago
          </Button>
        </Stack>
      </SmallModal>

      <PreviewModal openModal={openModal} selectedImage={selectedImage} setOpenModal={setOpenModal} setSelectedImage={setSelectedImage} />
    </div>
  );
};

export default CreditAbono;
